import * as Sentry from '@sentry/react';

const env = import.meta.env.REACT_APP_SENTRY_ENV || 'development';
const dsn = import.meta.env.REACT_APP_SENTRY_DSN;
const traceSampleRate = parseFloat(import.meta.env.REACT_APP_SENTRY_TRACE_SAMPLE_RATE || '0');

if (dsn) {
  Sentry.init({
    dsn,
    environment: env,
    release: import.meta.env.REACT_APP_SENTRY_RELEASE,
    tracesSampleRate: traceSampleRate || 0.1,
    debug: env === 'development',
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: false,
      }),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event: Sentry.ErrorEvent, hint: Sentry.EventHint) {
      const error = hint.originalException;
      if (error && typeof error === 'object' && 'statusCode' in error) {
        const status = (error as any).statusCode;
        if ([401, 404, 409].includes(status)) {
          return null;
        }
      }

      const message = event.message || event.exception?.values?.[0]?.value || '';
      const ignoredMessages = [
        'Ocorreu um erro inesperado',
        'Importing a module script failed',
        'Failed to fetch dynamically imported module',
        'NotAllowedError',
        'captureError',
        'removeChild',
        'You do not have permission to perform this action',
      ];

      if (ignoredMessages.some((msg) => message.includes(msg))) {
        return null;
      }

      return event;
    },
  });
}
